import { RevisionBulkActionProps, RevisionRow } from 'components/tables/data/revision/types';
import { useState } from 'react';
import Button from 'components/Button';
import { IconX } from '@tabler/icons-react';
import useRejectAction from 'components/tables/data/revision/actions/hooks/use-reject-action';
import { noop } from 'lodash';
import { getBulkRevisionKindGroup } from 'components/tables/data/revision/actions/bulk/kind-utils';
import BulkRejectConfirmMessage from 'components/tables/data/revision/actions/bulk/BulkRejectConfirmMessage';

/**
 * Performs a bulk reject on all selected rows.
 */
export default function BulkRejectAction({
  revisions,
  onStatusChange = noop,
  onBulkActionComplete = noop,
}: RevisionBulkActionProps) {
  const { rejectRevision } = useRejectAction();
  const availableRevisions: RevisionRow[] =
    getBulkRevisionKindGroup(revisions) === 'mixed'
      ? []
      : revisions.filter(
          (revision) =>
            revision.revisionStatus.slug === 'finished-waiting-for-approval' && revision.actionPermissions.canApprove
        );
  const [modalOpened, setModalOpened] = useState(false);

  /**
   * Rejects all selected revisions.
   */
  const rejectAll = () => setModalOpened(true);

  /**
   * Handles confirmation from the modal.
   */
  const handleConfirmReject = async (reason?: string) => {
    for (const revision of availableRevisions) {
      await rejectRevision({ revision, reason, onStatusChange });
    }
    onBulkActionComplete();
  };

  if (availableRevisions.length === 0) {
    return <></>;
  }

  return (
    <>
      <Button variant="primary" size="sm" leftIcon={<IconX />} onClick={rejectAll}>
        Zamietnuť ({availableRevisions.length})
      </Button>
      <BulkRejectConfirmMessage
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={availableRevisions[0]?.kind === 'revision' ? 'Zamietnuť revízne správy' : 'Zamietnuť formuláre'}
        message={
          availableRevisions[0]?.kind === 'revision'
            ? 'Naozaj si prajete zamietnuť vybrané revízne správy?'
            : 'Naozaj si prajete zamietnuť vybrané formuláre?'
        }
        revisions={availableRevisions}
        onConfirm={handleConfirmReject}
      />
    </>
  );
}
